import { render, staticRenderFns } from "./DocumentInformation.vue?vue&type=template&id=f5e2cb3e&scoped=true"
import script from "./DocumentInformation.vue?vue&type=script&lang=ts"
export * from "./DocumentInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e2cb3e",
  null
  
)

export default component.exports